import { Component, OnInit } from '@angular/core';
import { PatientResultService } from 'src/app/core/services/patientResult/patientResult.service';
import { ActivatedRoute } from '@angular/router';
import { IPatientResult } from 'src/app/models/IPatientResult';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-patientResult',
  templateUrl: './patientResult.component.html',
  styleUrls: ['./patientResult.component.scss'],
  providers:[PatientResultService]
})
export class PatientResultComponent implements OnInit {
  visitId: string;
  PatientResultModel: IPatientResult;
  constructor(private patientResultService:PatientResultService,private activatedRoute: ActivatedRoute,private messageService: MessageService) {
    this.activatedRoute.queryParams.subscribe(params => {
          let result = params['Result'] || params['result'];
          this.visitId = result;
      });
  }

  ngOnInit(): void {
    this.loadData();
  }
  loadData(){
    var resulturl = `/api/Queue/VisitReports?Result=`+this.visitId;
    this.patientResultService.getVisitReportsData(resulturl).subscribe({
      next:resultData => {
        this.PatientResultModel = resultData.Data;
      },
      error:err => {
        this.messageService.add({severity: 'error', summary: 'Error', detail:err.Message, life: 2000});
      }
    });
  }
  DownloadReport(){
    var resulturl = `/api/Queue/ShowReport?Result=`+this.PatientResultModel.EncruptedVisitId;
    this.patientResultService.getVisitReportsFiles(resulturl).subscribe({
      next:resultData => {
        if(resultData.Success){
          window.location=resultData.Message;
          //window.open(resultData.Message);
        }
        else{
          this.messageService.add({severity: 'error', summary: 'Error', detail:resultData.Message, life: 2000});
        }
      },
      error:err => {
        this.messageService.add({severity: 'error', summary: 'Error', detail:err.Message, life: 2000});
      }
    });
  }

  openViewer(){
    window.open(this.PatientResultModel.UniversalViewerBaseUrl, '_blank');
  }
}
